import api from '../unit/api'
import Cookie from 'js-cookie'
export default {
  state: {
    token: '',
    floorlist: [],
    Money: '',
    Operationmsgcount: 0,
    Operationmsg: '',
    count: 0,
    round: 0,
    msg: [],
    SPmsg: [],
    commit: 0,
    roundZeroCommitted: 0,
    planning: 0,
    budget: 0,
    depcomit: 0, //部门提交状态，当所有部门都提交时修改提交状态，进行提交，提交结束以后重置状态
    flowID: 0,
    marketCostStatistics: 0,
    taskBar: 0,
    operate: 0,
    checkSummarize: 0,
    path: '',
    chatShows:0,
    chatValue:0,
    buissId: 0
    // 市场调研报告 = 1, <<0
    // 举办地数据分析 = 2,  <<1
    // 场地询价 = 4,  <<2
    //项目管理 =1,<<0
    //会展营销 =2, <<1
    //数据分析 =4 <<2
    //会展服务=8 <<3
    //财务管理=16 <<4
  },
  mutations: {
    changepath(state, val){
      state.path = val
      localStorage.setItem('paths', val)
    },
    changeround(state, val) {
      state.round = val
      localStorage.setItem('CurrentRound', val)
      //Cookie.set('round', state.commit)
    },
    changedepcomit(state, val) {
      state.depcomit = val
      localStorage.setItem('depcomit', val)
      //Cookie.set('depcomit', state.depcomit)
    },
    operatedepcomit(state, val) {
      state.operate = val
      localStorage.setItem('operate', val)
      //Cookie.set('depcomit', state.depcomit)
    },
    checkSummarizecomit(state, val) {
      state.checkSummarize = val
      localStorage.setItem('checkSummarize', val)
      //Cookie.set('depcomit', state.depcomit)
    },
    coomitmd(state, val) {
      state.commit = val
      Cookie.set('commit', state.commit)
    },
    roundZeroCommittedmd(state, val) {
      state.roundZeroCommitted = val
      Cookie.set('roundZeroCommitted', state.roundZeroCommitted)
    },
    add(state) {
      state.count++
    },
    decrease(state) {
      state.count--
    },
    getloaddate(state) {
      state.Money = parseInt(Cookie.get('Money'))
      state.Operationmsg = Cookie.get('Operationmsg')
      state.Operationmsgcount = parseInt(
        typeof Cookie.get('Operationmsgcount') != 'number'
          ? 0
          : Cookie.get('Operationmsgcount')
      )
      state.path = localStorage.getItem('paths')
      state.round = parseInt(localStorage.getItem('CurrentRound'))
      state.commit = parseInt(Cookie.get('commit'))
      state.roundZeroCommitted = parseInt(Cookie.get('roundZeroCommitted'))
      state.depcomit = parseInt(localStorage.getItem('depcomit'))
      let msglist = JSON.parse(localStorage.getItem('msg'))
      state.msg = []
      if (msglist != null)
        for (let index = 0; index < msglist.length; index++) {
          const msgitem = msglist[index]
          state.msg.push(msgitem)
        }
      let SPmsglist = JSON.parse(localStorage.getItem('SPmsg'))
      state.SPmsg = []
      if (SPmsglist != null)
        for (let index = 0; index < SPmsglist.length; index++) {
          const spmsgitem = SPmsglist[index]
          state.SPmsg.push(spmsgitem)
        }
    },
    chagemsg(state, val) {
      console.log(val.money)
      state.msg.push(val)
      localStorage.setItem('msg', JSON.stringify(state.msg))
    },
    chageSPmsg(state, val) {
      console.log(val.money)
      //todo 这里判断一下如果是自身发出去的，不写入本地缓存
      const index = state.SPmsg.findIndex((item) => item.guid === val.guid)
      if (index < 0 || val.guid == '') {
        state.SPmsg.push(val)
        localStorage.setItem('SPmsg', JSON.stringify(state.SPmsg))
      } else if (index >= 0) {
        state.SPmsg.find((item) => item.guid === val.guid).msg = val.msg
        localStorage.setItem('SPmsg', JSON.stringify(state.SPmsg))
      }
    },
    setMoney(state, val) {
      state.Money = val
      Cookie.set('Money', val)
    },
    setOperationmsg(state, val) {
      state.Operationmsg = val
      state.Operationmsgcount += 1
      //alert(state.Operationmsgcount)
      Cookie.set('Operationmsg', val)
      Cookie.set('Operationmsgcount', state.Operationmsgcount)
    },
    setToken(state, val) {
      state.token = val
      Cookie.set('token', val)
    },
    clearToken(state) {
      state.token = ''
      Cookie.remove('token')
    },
    getToken(state) {
      state.token = Cookie.get('token')
    },
    setfloorlist(state, val) {
      state.floorlist = val
      localStorage.setItem('floorlist', JSON.stringify(val))
      //Cookie.set('floorlist', JSON.stringify(val))
    },
    clearfloorlist(state) {
      state.floorlist = []
      //Cookie.remove('floorlist')
      localStorage.removeItem('floorlist')
    },
    exhibitionPlanning(state, val) {
      state.planning = val
      Cookie.set('planning', state.planning)
    },
    budgetCustomized(state, val) {
      state.budget = val
      Cookie.set('budget', state.budget)
    },
    marketStatistics(state, val) {
      state.marketCostStatistics = val
      Cookie.set('marketCostStatistics', state.marketCostStatistics)
    },
    GetTaskBar(state, val) {
      state.taskBar = val
      Cookie.set('taskBar', state.taskBar)
    },
    getfloorlist(state) {
      if (
        localStorage.getItem('floorlist') != 'undefined' &&
        localStorage.getItem('floorlist') != undefined
      ) {
        state.floorlist = JSON.parse(localStorage.getItem('floorlist'))
      } else {
        api.getfloorlistmd(state.round).then((res) => {
          state.floorlist = res
          console.log(state.floorlist)
          localStorage.setItem('floorlist', JSON.stringify(res))
          //Cookie.set('floorlist', JSON.stringify(res));
        })
        //  alert(floorlist)
        //  state.floorlist=floorlist;
        //  Cookie.set('floorlist',JSON.stringify(floorlist));
      }
    },
    chatShow(state, val) {
      state.chatShows = val.isOperate
      state.chatValue = val.chatValue
      state.buissId = val.buissId
      Cookie.set('chatShows', state.chatShows)
    },
  },

  actions: {
    delayAdd(context) {
      setTimeout(() => {
        context.commit('add')
      }, 1000)
    },
  },
}
